import { connect } from 'react-redux'

import { MODE_IDS } from 'common/utils/constants'

import TicketsApp from 'tickets/components/TicketsApp'
import {
  getSearchOrigin,
  getSearchDestination,
  getCurrentModeId,
} from 'tickets/redux/modules/router/selectors'
import {
  getHasHeader,
  getOutboundTicket,
  getIsInvalidHistoryState,
} from 'tickets/redux/modules/searchResponses/selectors'
import { getIsActiveModePolling } from 'tickets/redux/modules/modesInfo/selectors'
import { getIsError } from 'tickets/redux/modules/searchConfig/selectors'
import searchResponsesOperations from 'tickets/redux/modules/searchResponses/operations'
import selectionOperations from 'tickets/redux/modules/selections/operations'
import searchParamsOperations from 'tickets/redux/modules/searchParams/operations'

const mapStateToProps = state => ({
  originDestination: {
    origin: getSearchOrigin(state),
    destination: getSearchDestination(state),
  },
  hasHeader: getHasHeader(state),
  error: getIsError(state),
  hasOutbound: !!getOutboundTicket(state),
  isPolling: getIsActiveModePolling(state),
  displayFerry: getCurrentModeId(state) == MODE_IDS.ferry,
  isInvalidHistoryState: getIsInvalidHistoryState(state),
})

const mapDispatchToProps = {
  performSearch: searchResponsesOperations.performSearch,
  modeChanged: selectionOperations.modeChanged,
  onInitMode: searchParamsOperations.updateHandoverMode,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketsApp)
